import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getReadoutName, getScopeName, getViewName } from '../../utils/nameFormat';
const productReadout = getReadoutName('Product');
export const removeReadoutStmtInstruction = `
#### Remove readout from scope
Use this command to remove a readout from a specific scope.

- Syntax: \`remove readout <readout_name> in <view_name>.<scope_name>;\`
- Example: \`remove readout ${productReadout} in ${getViewName({ entityName: 'Product', viewType: 'create' })}.${getScopeName({ entityName: 'Product' })};\`
- Example: \`remove readout ${productReadout} in ${getViewName({ entityName: 'Product', viewType: 'edit' })}.${getScopeName({ entityName: 'Product' })};\`

#### Remove readout
Use this command to remove a readout from the application structure.

- Syntax: \`remove readout <readout_name>;\`
- Example: \`remove readout ${productReadout};\`
`;
export const stmtRemoveReadout = ({ readoutName, scopeName, viewName }) => {
    if (viewName && scopeName) {
        return `remove readout ${readoutName} in ${viewName}.${scopeName};`;
    }
    return `remove readout ${readoutName};`;
};
export const removeReadoutHandler = createStructureStatementHandler({
    type: 'remove readout',
    parse: line => {
        const match = /^remove (readout|detail) (?<readoutName>\w+)( in (?<viewName>\w+).(?<scopeName>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'remove readout',
                readoutName: match.groups.readoutName,
                scopeName: match.groups.scopeName,
                viewName: match.groups.viewName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.removeReadout({
                readoutName: stmt.readoutName,
                viewName: stmt.viewName,
                scopeName: stmt.scopeName,
            });
        });
    },
});
//# sourceMappingURL=RemoveReadoutStmt.js.map